<div class="main-container">
  <ng-container *ngIf="dataSource">
    <section class="table-panel">
    <div class="panel-header">
    <h3 class="page-title">Annotations ({{ metaData.totalItems || 0 }})</h3>
    <div class="header-actions flex items-center gap-2">
      <app-search-field
        [value]="filters.q"
        [debounce]="300"
        (debouncedChange)="onDebouncedSearch($event)"
      ></app-search-field>
      <mat-icon
        *ngIf="ability.canCreate(ability.subjects.Annotation)"
        class="cursor-pointer text-accent"
        fontSet="material-symbols-outlined"
        matTooltip="Add annotation"
        aria-label="Add annotation"
        (click)="createNewUser()"
        >add</mat-icon
      >
    </div>
    </div>
    <div class="table-container"
    [ngClass]="loader ? 'mat-loader-enabled' : ''"
    >
    <mat-spinner class="mat-loader" diameter="30" strokeWidth="4" *ngIf="loader"></mat-spinner>
      <table class="table-bordered" mat-table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="typeId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Annotation Type ID</th>
          <td class="annotation-td" mat-cell *matCellDef="let element"> <span class="annotation-color" [style.opacity]="element.opacity" [style.backgroundColor]="element.color"> </span> {{element.typeId}} </td>
        </ng-container>

        <ng-container matColumnDef="eventType">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Event Type</th>
          <td mat-cell *matCellDef="let element"> {{element.eventType}} </td>
        </ng-container>

        <ng-container matColumnDef="label">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Label</th>
          <td mat-cell *matCellDef="let element"> {{element.label}} </td>
        </ng-container>
        <ng-container matColumnDef="comments">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> Comment</th>
          <td mat-cell *matCellDef="let element"> {{element.comments}} </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Actions</th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button (click)="ediAnnotation(element)"><mat-icon class="edit">edit</mat-icon> </button>
            <button  mat-icon-button *ngIf="!element.isDefault && ability.canDelete(ability.subjects.Annotation)" class="action-span" (click)="openDialog(element)"><mat-icon class="delete">delete_outline</mat-icon></button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <app-pagination class="border-t border-divider" [page]="metaData.currentPage" [pageSize]="metaData.itemsPerPage"
      [totalItems]="metaData.totalItems" [disabled]="loader"
      (pageChange)="goToPage($event)" (pageSizeChange)="onPageSizeChange($event)"></app-pagination>
    </section>

  </ng-container>
</div>
